<template>
  <div class="homepage-component hp-quick-links" role="region" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="quick-links-component padding-lg">
      <div class="container">
        <div class="row text-center title-row">
          <div class="col-xs-12">
            <h2 class="themed-underline">We're here for anything you need</h2>
          </div>
        </div>
        <div class="row links-row">
          <div class="col-xs-12 col-sm-6 col-md-4 col-md-offset-custom-2 col-lg-3 quick-link-col animation-element slide-right">
            <a href="#" class="quick-link">
              <div class="link-box" id="quick-link-01" :style="{backgroundImage: inventoryBox}">
                <div class="box-overlay">
                  <h3 class="quick-link__title">View our Inventory</h3>
                  <div class="quick-link__btn kia-secondary-btn">Shop Now</div>
                </div>
              </div>
            </a>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 quick-link-col animation-element slide-right reveal2">
            <a href="#" class="quick-link">
              <div class="link-box" id="quick-link-02">
                <div class="box-overlay">
                  <h3 class="quick-link__title">Reserve your new {{ brandName }} today</h3>
                  <div class="quick-link__btn kia-secondary-btn">Reserve Now</div>
                </div>
              </div>
            </a>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4 col-md-offset-custom-2 col-lg-3 quick-link-col animation-element slide-right reveal3">
            <a href="#" class="quick-link">
              <div class="link-box" id="quick-link-03">
                <div class="box-overlay">
                  <h3 class="quick-link__title">Sell or trade your car</h3>
                  <div class="quick-link__btn kia-secondary-btn">Learn More</div>
                </div>
              </div>
            </a>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 quick-link-col animation-element slide-right reveal4">
            <a href="#" class="quick-link">
              <div class="link-box" id="quick-link-04">
                <div class="box-overlay">
                  <h3 class="quick-link__title">Service you can count on</h3>
                  <div class="quick-link__btn kia-secondary-btn">Schedule Now</div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['images'],
    data() {
      return {
        brand: this.$store.state.chosenBrand,
      }
    },
    computed: {
      brandName () {
        if (this.brand === 'none') {
          return 'vehicle';
        } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
          return this.brand.toUpperCase();
        } else {
          return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
        }
      },
      inventoryBox () {
        if (this.brand === 'kia' || this.brand === 'cjdr' || this.brand === 'ford' || this.brand === 'infiniti') {
          return 'url(' + this.images.lifestyleImages.defaultImage + ')';
        } else if (this.brand === 'none') {
          return 'url(' + this.images.lifestyleImages.sedanImage + ')';
        } else if (this.brand === 'chevrolet' || this.brand === 'nissan') {
          return 'url(' + this.images.lifestyleImages.truckImage + ')';
        } else {
          return 'url(' + this.images.lifestyleImages.suvImage + ')';
        }
      }
    },
    mounted() {
      $(function() {
        var scrollSwoop = {
          init: function() {
            var $animation_elements = $('.animation-element');
            var $window = $(window);
          
            function check_if_in_view() {
              var window_height = $window.height() * .85;
              var window_top_position = $window.scrollTop();
              var window_bottom_position = (window_top_position + window_height);
              $.each($animation_elements, function() {
                var $element = $(this);
                var element_height = $element.outerHeight();
                var element_top_position = $element.offset().top;
                var element_bottom_position = (element_top_position + element_height);
          
                if ((element_bottom_position >= window_top_position) &&
                    (element_top_position <= window_bottom_position)) {
                  if ($element.hasClass("reveal2") === true) {
                    setTimeout(function() {
                      $element.addClass('in-view');
                    }, 300);
                  }
                  else if ($element.hasClass("reveal3") === true) {
                    setTimeout(function() {
                      $element.addClass('in-view');
                    }, 600);
                  } 
                  else if ($element.hasClass("reveal4") === true) {
                    setTimeout(function() {
                      $element.addClass('in-view');
                    }, 900);
                  }
                  else {
                    $element.addClass('in-view');
                  }
                }
              });
            }
            $window.on('scroll resize', check_if_in_view);
            $window.trigger('scroll');
          }
        }
        $(document).ready(scrollSwoop.init);
      });
    }
  };
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.quick-link, 
.quick-link:hover, 
.quick-link:active, 
.quick-link:focus {
  text-decoration: none;
  outline: none;
}
.quick-link .link-box {
  background-position: center;
  background-size: cover;
  border-radius: 12px;
  margin: 15px auto;
  max-width: 460px;
  background-color: rgba(55, 67, 77, 1);
  background-blend-mode: luminosity;
}
.quick-link .link-box:hover {
  -webkit-transform: scale3d(1.05, 1.05, 1.05);
  transform: scale3d(1.05, 1.05, 1.05);
}
.quick-link .link-box .box-overlay {
  background: transparent linear-gradient(180deg, rgba(105,114,121,25%), rgba(5,20,31,100%)) 0% 0% no-repeat padding-box;
  border-radius: 12px;
  padding: 15px;
  height: 485px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.quick-link .link-box, 
.quick-link .link-box .box-overlay {
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.quick-link .link-box .box-overlay:hover {
  background-color: rgba(5, 20, 31, 0.75);
}
.quick-link .quick-link__title {
  color: #fff;
  min-height: 53px;
}
#quick-link-02 {
  background-image: url(../../static/images/trade-in-stock-img.jpeg);
  background-position-x: 65%;
}
#quick-link-03 {
  background-image: url(../../static/images/financing-stock-img.jpeg);
  background-position-x: 40%;
}
#quick-link-04 {
  background-image: url(../../static/images/parts-service-stock-image.jpeg);
}
.quick-link-col .quick-link__btn {
  border: none;
}
.kia-secondary-btn {
  background-color: #ffffff;
  color: #05141F;
  font-size: 16px;
  font-weight: 500;
  padding: 10px 34px;
  border-radius: 0;
  border: 1px solid #05141F;
  margin: 30px 0;
  -webkit-transition: .3s all ease;
  -o-transition: .3s all ease;
  -moz-transition: all 0.3s ease;
  transition: .3s all ease;
}
.kia-secondary-btn:hover, .kia-secondary-btn:active, .kia-secondary-btn:focus {
  background-color: #05141F;
  color: #ffffff !important;
  text-decoration: none;
}
.quick-link-col .quick-link__btn:hover {
  box-shadow: 0px 0px 10px 15px rgb(255 255 255 / 50%);
}
@media (min-width: 992px) and (max-width: 1199px) {
  .quick-links-component .col-md-offset-custom-2 {
    margin-left: 16.6666666667%;
  }
}
@media (max-width: 991px) {
  .quick-link .link-box {
    max-width: 350px;
  }
}
.animation-element.slide-right {
  opacity: 0;
  -moz-transition: all 700ms linear;
  -webkit-transition: all 700ms linear;
  -o-transition: all 700ms linear;
  transition: all 700ms linear;
  transition-property: opacity, transform;
  -moz-transform: translate3d(50px, 0px, 0px);
  -webkit-transform: translate3d(50px, 0px, 0px);
  -o-transform: translate(50px, 0px);
  -ms-transform: translate(50px, 0px);
  transform: translate3d(50px, 0px, 0px);
}

.animation-element.slide-right.in-view {
  opacity: 1;
  -moz-transform: translate3d(0px, 0px, 0px);
  -webkit-transform: translate3d(0px, 0px, 0px);
  -o-transform: translate(0px, 0px);
  -ms-transform: translate(0px, 0px);
  transform: translate3d(0px, 0px, 0px);
}

.hp-quick-links[data-brand="kia"] h2, .hp-quick-links[data-brand="kia"] h3 {
  font-weight: bold;
}
</style>